import { render, staticRenderFns } from "./AdminSessionsDashboard.vue?vue&type=template&id=01f4ad1c"
import script from "./AdminSessionsDashboard.vue?vue&type=script&lang=ts"
export * from "./AdminSessionsDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports